import React from 'react';
import propTypes from 'prop-types';
export const GlobeIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path
          stroke="none"
          fillRule="nonzero"
          fill={color}
          fillOpacity="1"
          d="M 16.148438 7.5 C 15.46875 3.3125 13.867188 0.375 12 0.375 C 10.132812 0.375 8.53125 3.3125 7.851562 7.5 Z M 7.5 12 C 7.5 13.039062 7.554688 14.039062 7.65625 15 L 16.339844 15 C 16.4375 14.039062 16.496094 13.039062 16.496094 12 C 16.496094 10.960938 16.4375 9.960938 16.339844 9 L 7.65625 9 C 7.554688 9.960938 7.5 10.960938 7.5 12 Z M 22.71875 7.5 C 21.378906 4.316406 18.664062 1.855469 15.3125 0.863281 C 16.457031 2.445312 17.246094 4.832031 17.65625 7.5 Z M 8.679688 0.863281 C 5.335938 1.855469 2.617188 4.316406 1.28125 7.5 L 6.34375 7.5 C 6.75 4.832031 7.539062 2.445312 8.679688 0.863281 Z M 23.222656 9 L 17.84375 9 C 17.945312 9.984375 18 10.992188 18 12 C 18 13.007812 17.945312 14.015625 17.84375 15 L 23.21875 15 C 23.476562 14.039062 23.621094 13.039062 23.621094 12 C 23.621094 10.960938 23.476562 9.960938 23.222656 9 Z M 6 12 C 6 10.992188 6.054688 9.984375 6.15625 9 L 0.777344 9 C 0.523438 9.960938 0.375 10.960938 0.375 12 C 0.375 13.039062 0.523438 14.039062 0.777344 15 L 6.148438 15 C 6.054688 14.015625 6 13.007812 6 12 Z M 7.851562 16.5 C 8.53125 20.6875 10.132812 23.625 12 23.625 C 13.867188 23.625 15.46875 20.6875 16.148438 16.5 Z M 15.320312 23.136719 C 18.664062 22.144531 21.382812 19.683594 22.726562 16.5 L 17.664062 16.5 C 17.25 19.167969 16.460938 21.554688 15.320312 23.136719 Z M 1.28125 16.5 C 2.621094 19.683594 5.335938 22.144531 8.6875 23.136719 C 7.542969 21.554688 6.753906 19.167969 6.34375 16.5 Z M 1.28125 16.5 "
        />
      </g>
    </svg>
  );
};
GlobeIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
GlobeIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
